import { useContext, useEffect, useRef, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import projectStore from "../../../Store/projectStore";
import _ from "underscore";
import { decryptData } from "../../../utils/encrypt";
import { callautopopulate } from "../../../services/callautopop";
import { Dropdown } from "primereact/dropdown";
import { secondsToHours } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";

export const useTimeMatrix = () => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const { options, getFilterOptions } = projectStore();
    const [opts, setOpts] = useState({});
    const [columns, setColumns] = useState([]);
    const [rowData, setRowData] = useState({ api: [], data: [] });
    const colorCodes = { lowest: "#b6e7b6", veryLow: "#daf7da", low: "#fff0cd", medium: "#ffd9a8", high: "#fdd9d9", veryHigh: "#fbcaca", highest: "#ffb8b8" }
    const [editData, setEditData] = useState({ isEditing: false, previous: {}, updated: {} });
    const [tooltip, setTooltip] = useState({});
    const [loader, setLoader] = useState({ matrix: false, btn: false });

    useEffect(() => {
        callautopopulate("bid_seconds")?.then(res => {
            res?.bid_seconds?.forEach(item => {
                item.label = secondsToHours(item.bid_seconds);
            });
            setOpts((prev) => ({ ...prev, bid_seconds: res?.bid_seconds }));
        })
        getFilterOptions([{ key: "issue_complexity", optionLabel: "order_number" }, { key: "issue_logitivity", optionLabel: "issue_logitivity_name" }])
        getMatrixData();
    }, [])

    useEffect(() => {
        (!_.isEmpty(options?.issue_complexity) && !_.isEmpty(options?.issue_logitivity) && !_.isEmpty(opts?.bid_seconds)) && formatMatrixCells();
    }, [options?.issue_logitivity, options?.issue_complexity, opts?.bid_seconds, editData, rowData?.api])

    const getMatrixData = async () => {
        try {
            setLoader((prev) => ({ ...prev, matrix: true }));
            const res = await services.getInvokeRemote("POST", Urls("GETTASKTIMEMATRIXDETAIL"), {});
            if (!res?.error_status) {
                const data = res?.body?.data?.task_time_matrix_details;
                setRowData((prev) => ({ ...prev, api: data }));
            }
            setLoader((prev) => ({ ...prev, matrix: false }));
        } catch (error) {
            console.error("Error", error);
            setLoader((prev) => ({ ...prev, matrix: false }));
        }
    }

    const formatMatrixCells = () => {
        // set row data
        let rowdata = _.sortBy([...options?.issue_logitivity], "order_number");
        rowdata?.map(long => {
            options?.issue_complexity?.forEach(comp => {
                let colorKey = '';

                if ((long?.order_number === 1 && comp?.order_number <= 3) || (long?.order_number === 2 && comp?.order_number === 1)) {
                    colorKey = "lowest";
                } else if ((long?.order_number === 1 && comp?.order_number <= 6) || (long?.order_number === 2 && comp?.order_number <= 3) || ((long?.order_number === 3 || long?.order_number === 4) && comp?.order_number === 1)) {
                    colorKey = "veryLow";
                } else if ((long?.order_number === 3 && comp?.order_number <= 3) || (long?.order_number === 4 && comp?.order_number === 2) || ((long?.order_number === 5 || long?.order_number === 6) && comp?.order_number === 1)) {
                    colorKey = "low";
                } else if ((long?.order_number === 2 && (comp?.order_number <= 5)) || (long?.order_number === 3 && comp?.order_number === 4) || (long?.order_number === 4 && comp?.order_number === 3) || (long?.order_number === 5 && comp?.order_number === 2)) {
                    colorKey = "medium";
                } else if ((long?.order_number === 3 && comp?.order_number === 5) || (long?.order_number === 4 && comp?.order_number === 4) || (long?.order_number === 5 && comp?.order_number === 3) || (long?.order_number === 6 && comp?.order_number === 2)) {
                    colorKey = "high";
                } else if (long?.order_number === 4 && comp?.order_number === 5) {
                    colorKey = "veryHigh";
                } else if (long?.order_number === 3) {
                    colorKey = "veryHigh";
                } else if (long?.order_number === 2) {
                    colorKey = "high";
                } else if (long?.order_number === 4 || long?.order_number === 5 || long?.order_number === 6) {
                    colorKey = "highest";
                }
                long[`${comp?.issue_complexity_id}_color`] = colorCodes?.[colorKey]

                // set dropdown data
                const findData = _.findWhere(rowData?.api, { dimensions: long?.issue_logitivity_name });
                const min = _.findWhere(opts?.bid_seconds, { bid_seconds: parseFloat(findData?.[comp?.issue_complexity_id]?.split("-")?.[0]?.trim()) * 3600 }) || null
                const max = _.findWhere(opts?.bid_seconds, { bid_seconds: parseFloat(findData?.[comp?.issue_complexity_id]?.split("-")?.[1]?.trim()) * 3600 }) || null
                long[`${long?.issue_logitivity_id}_${comp?.issue_complexity_id}`] = { min, max }
                long[comp?.issue_complexity_id] = (_.isEmpty(min) && _.isEmpty(max)) ? null : findData?.[comp?.issue_complexity_id];
            })
        })
        setRowData((prev) => ({ ...prev, data: rowdata }));

        // set Columns
        let cols = [{
            key: "issue_logitivity_name",
            label: "Dimensions",
            sort: false,
            style: { width: "100px", padding: 0 },
            headerStyle: { textAlign: "center" },
            render: (row, index) => <div className="fw-bold ps-2">{row?.issue_logitivity_name}</div>
        }]
        options?.issue_complexity?.forEach(item => {
            cols.push({
                key: item?.issue_complexity_name,
                label: item?.issue_complexity_name,
                sort: false,
                style: { width: "185px", textAlign: "center", padding: 0 },
                headerStyle: { textAlign: "center", paddingLeft: 0 },
                render: (row) => {
                    const long = _.findWhere(options?.issue_logitivity, { issue_logitivity_name: row?.issue_logitivity_name })
                    const key = `${long?.issue_logitivity_id}_${item?.issue_complexity_id}`;
                    return (
                        editData?.isEditing ?
                            <div className="d-flex gap-1 justify-content-center align-items-center align-content-center px-1 time-matrix-dropdown" style={{ backgroundColor: row?.[`${item?.issue_complexity_id}_color`], height: "50px" }}>
                                <div style={{ width: "48%" }}>
                                    <Dropdown options={opts?.bid_seconds} value={editData?.updated?.[key]?.isMinNull ? null : editData?.updated?.[key]?.min || row?.[key]?.min} onChange={(e) => handleChange(row, key, "min", e.target?.value)} placeholder="min" showClear />
                                </div>

                                <div style={{ width: "48%" }}>
                                    <Dropdown options={opts?.bid_seconds} value={editData?.updated?.[key]?.isMaxNull ? null : editData?.updated?.[key]?.max || row?.[key]?.max} onChange={(e) => handleChange(row, key, "max", e.target?.value)} placeholder="max" showClear />
                                </div>
                            </div> :
                            <div className="fw-bold d-flex align-items-center justify-content-center" style={{ backgroundColor: row?.[`${item?.issue_complexity_id}_color`], height: "50px" }}>
                                {row?.[item?.issue_complexity_id?.toString()] && <div style={{ width: "fit-content", cursor: "default" }} className="time-matrix-tooltip" onMouseEnter={() => setTooltip({ longitivity: row?.issue_logitivity_name, complexity: item?.issue_complexity_name })}>{row?.[item?.issue_complexity_id?.toString()]}<br /><span style={{ color: "#717f93", fontSize: "0.7rem" }}>HRS</span></div>}
                            </div>
                    )
                }
            })
        })
        setColumns(cols);
    }

    const saveMatrixData = async () => {
        try {
            if (_.isEmpty(editData?.updated) || _.isEqual(editData?.previous, editData?.updated)) {
                showInfo("Info", "No changes made");
                return;
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            let error = "";
            let tvp = [];
            Object.entries(editData?.updated)?.forEach(([key, value]) => {
                if (!_.isEqual(editData?.previous?.[key], value)) {
                    const min = value?.min?.bid_seconds / 3600 || 0;
                    const max = value?.max?.bid_seconds / 3600 || 0;
                    if (min > max) {
                        error = "Minimum hours cannot be greater than maximum hours";
                        return;
                    } else if(min === 0 && max !== 0) {
                        error = "Minimum hours cannot be 0 if maximum hours is non-zero";
                        return;
                    }
                    tvp.push({
                        matrix_id: 0,
                        longitivity_id: key?.split("_")?.[0],
                        complexity_id: key?.split("_")?.[1],
                        min_hours: min,
                        max_hours: max
                    })
                }
            })
            if (error) {
                showInfo("Info", error);
                setLoader((prev) => ({ ...prev, btn: false }));
                return;
            }
            const payload = {
                time_matrix: tvp
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTASKTIMEMATRIXDETAIL"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setEditData((prev) => ({ ...prev, isEditing: false, updated: {}, previous: {} }));
                getMatrixData();
            }
            setLoader((prev) => ({ ...prev, btn: false }));
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const handleChange = (row, dataKey, key, value) => {
        let min = editData?.updated?.[dataKey]?.isMinNull ? null : editData?.updated?.[dataKey]?.min || row?.[dataKey]?.min;
        let max = editData?.updated?.[dataKey]?.isMaxNull ? null : editData?.updated?.[dataKey]?.max || row?.[dataKey]?.max;
        if (key === "min") {
            min = value || null
        } else if (key === "max") {
            max = value || null
        }
        if (min?.bid_seconds > max?.bid_seconds) {
            showInfo("Info", "Minimum hours cannot be greater than maximum hours");
            return;
        }
        setEditData((prev) => ({ ...prev, previous: { ...prev?.previous, [dataKey]: { min: row?.[dataKey]?.min, max: row?.[dataKey]?.max } }, updated: { ...prev?.updated, [dataKey]: { min: min, max: max, isMinNull: !min, isMaxNull: !max }, } }));
    }

    return { getMatrixData, options, columns, rowData, editData, setEditData, saveMatrixData, tooltip, loader }
}